import api from './api';

export interface UserActivity {
  id: number;
  user_id: number;
  username: string;
  action_type: string;
  module: string;
  description: string;
  ip_address: string;
  user_agent: string;
  created_at: string;
  full_name?: string;
  role?: string;
}

export interface UserActivityResponse {
  activities: UserActivity[];
  total: number;
}

export const userActivityService = {
  getUserActivity: async (
    userId: number,
    params?: {
      limit?: number;
      offset?: number;
      action_type?: string;
      module?: string;
      startDate?: string;
      endDate?: string;
    }
  ): Promise<UserActivityResponse> => {
    const response = await api.get(`/activity/user/${userId}`, { params });
    return response.data;
  },

  getAllActivity: async (params?: {
    limit?: number;
    offset?: number;
    action_type?: string;
    module?: string;
    startDate?: string;
    endDate?: string;
  }): Promise<{ activities: UserActivity[]; count: number }> => {
    const response = await api.get('/activity/all', { params });
    return response.data;
  },

  logActivity: async (data: {
    action_type: string;
    module: string;
    description: string;
  }): Promise<{ message: string }> => {
    const response = await api.post('/activity', data);
    return response.data;
  },
};
